import { type NoteImage as NoteImageType } from '@/api/client-notes';
import { NoteImage } from './NoteImage';

interface ImageThumbnailsProps {
  clientId: number;
  noteId: string;
  images: NoteImageType[];
  onImageClick?: (index: number) => void;
  size?: 'sm' | 'md';
}

export function ImageThumbnails({
  clientId,
  noteId,
  images,
  onImageClick,
  size = 'sm',
}: ImageThumbnailsProps) {
  if (images.length === 0) {
    return null;
  }

  const sizeClass = size === 'sm' ? 'w-12 h-12' : 'w-16 h-16';

  const Wrapper = onImageClick ? 'button' : 'div';

  return (
    <div className="flex flex-wrap gap-1.5 mt-1.5">
      {images.map((image, index) => (
        <Wrapper
          key={image.id}
          type={onImageClick ? 'button' : undefined}
          onClick={onImageClick ? (e: React.MouseEvent) => {
            e.stopPropagation();
            onImageClick(index);
          } : undefined}
          className={`${sizeClass} rounded overflow-hidden border dark:border-gray-700 ${onImageClick ? 'hover:border-primary transition-colors' : ''}`}
        >
          <NoteImage
            clientId={clientId}
            noteId={noteId}
            imageId={image.id}
            alt={image.originalName}
            thumb
            className="w-full h-full object-cover"
          />
        </Wrapper>
      ))}
    </div>
  );
}
